__turbopack_context__.v({
  "Button": "index-module__4lDDCW__Button",
  "Container": "index-module__4lDDCW__Container",
  "Label": "index-module__4lDDCW__Label",
  "Toggle": "index-module__4lDDCW__Toggle",
  "ToggleRow": "index-module__4lDDCW__ToggleRow",
});
